export enum DatePickerType {
    Month = 'month',
    MonthRange = 'month-range',
    Range = 'range',
    Single = 'single'
}
